// extracted by mini-css-extract-plugin
export default {"newchat-main":"NewChat_newchat-main__cCDIa","text-section":"NewChat_text-section__pzTSV","gradientAnimation":"NewChat_gradientAnimation__Y3Dip"};